import fetch from "../connector";
import { PATH_BASE_URL } from "../../../components/pages/App/constants";
import { getTaxPayer, getContribitor } from "./constants";

export const getTaxPayerData = (cuit) =>
  fetch(PATH_BASE_URL, getTaxPayer(cuit), {
    method: "GET",
  });

export const getContributorData = (cuit) =>
  fetch(PATH_BASE_URL, getContribitor(cuit), {
    method: "GET",
  });
